// extracted by mini-css-extract-plugin
module.exports = {"describe":"describe___2kamk","label":"label___2fLIm","content":"content___Co9GU"};